<template>
  <div class="item-container">
    <!-- Header row -->
    <TourHeader :item="item" @clicked="toggleExpand" />

    <!-- Content for Tour -->
    <div v-if="dropdown" class="item-dropdown">
      <div class="item-dropdown-main">
        <!-- Mobile Header-->
        <ul>
          <MobileHeader :item="item" />

          <!-- Loop over all expanderItems -->
          <li v-for="expanderItem in item.expanderItems" :key="expanderItem.title">
            <h4>{{ expanderItem.title }}</h4>
            <p style="padding-top: 12px; padding-left: 5px">
              {{ expanderItem.notes }}
            </p>
          </li>

          <!-- Itinerary-->
          <li v-if="
            returnAdditionalInformation('itinerary') &&
            !isFriendFamily &&
            item.tourtype !== 'CRUISE'
          ">
            <h4>Itinerary</h4>
            <p style="
                padding-top: 12px;
                padding-left: 5px;
                white-space: pre-wrap;
              " v-html="returnAdditionalInformation('itinerary')" />
          </li>

          <!-- tour details extras-->
          <li v-if="returnAdditionalInformation('extras')">
            <h4>Extras</h4>
            <p style="padding-top: 12px; white-space: pre-wrap">
              {{ returnAdditionalInformation("extras") }}
            </p>
          </li>
          <!-- tour details inclusions-->
          <li v-if="returnAdditionalInformation('inclusions')">
            <h4>Inclusions</h4>
            <p style="padding-top: 12px; white-space: pre-wrap">
              {{ returnAdditionalInformation("inclusions") }}
            </p>
          </li>
          <!-- tour details accomodation-->
          <li v-if="returnAdditionalInformation('accommodation')">
            <h4>Accommodation</h4>
            <p style="padding-top: 12px; white-space: pre-wrap">
              {{ returnAdditionalInformation("accommodation") }}
            </p>
          </li>
        </ul>

        <div class="extra-info">
          <div class="extra-info-img">
            <div v-if="
              (item.imageurl && item.imageurl.length > 0) ||
              (typeof item.imageurl === 'Object' &&
                Object.keys(item.imageurl).includes('750x750'))
            " class="mb-1 custom-video-player">
              <Lightbox :thumbnail="videoImage()" :images="images" :show-play="item.showPlay ? item.showPlay : false"
                :is-default-img="item.isDefaultImg ? item.isDefaultImg : false" />
            </div>
            <div class="extra-info-alt p-0 mb-0">
              <div v-if="Object.keys(tour_data).length > 0">
                <button v-if="
                  (item.operator.indexOf('G ADVENTURES') >= 0 &&
                    item.advtourcode) ||
                  (item.operator.indexOf('TRUTRAVELS') >= 0 &&
                    item.advtourcode)
                " class="extra-info" @click="openTourInfoModal">
                  <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>Tour Information</span>
                </button>
              </div>
              <button v-if="
                item.operator.indexOf('INTREPID TRAVEL') >= 0 &&
                item.advtourcode !== '' &&
                intrepid_holiday_data &&
                Object.keys(intrepid_holiday_data).length > 0
              " class="extra-info" @click="openIntrepidTripInfoModal">
                <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>Trip Information</span>
              </button>

              <button v-if="
                item.operator.indexOf('EXODUS') >= 0 &&
                item.advtourcode !== '' &&
                exodus_holiday_data &&
                Object.keys(exodus_holiday_data).length > 0
              " class="extra-info" @click="openExodusHolidayInfoModal">
                <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>Trip Information</span>
              </button>
              <button v-if="
                item.operator.indexOf('EXPLORE') >= 0 &&
                item.advtourcode !== '' &&
                (explore_holiday_data &&
                  Object.keys(explore_holiday_data).length) > 0
              " class="extra-info" @click="openExploreTripInfoModal">
                <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>Trip Information</span>
              </button>

              <!-- <button v-if="item.operator.indexOf('AAT KINGS') >= 0 && item.esctourcode !== ''" class="extra-info"
                @click="openAATKingsTripInfoModal">
                <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>Trip Information</span>
              </button> 
              -->

              <button v-if="item.tptfile" @click="openTourPDF(item.tptfile)">
                <i class="material-icons vtd-icon-2 vtd-mr-3">info</i>
                <span>{{ capitalise(item.tourtype) }} Itinerary</span>
              </button>
              <button v-if="item.customitinfile" @click="openLink(`/${item.customitinfile}`)">
                <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>View Detailed Customised Itinerary</span>
              </button>

              <ExtraInfoButtons itemtype="tour" :item="item" />

              <div v-if="hasEssenFile" class="hol-essentials">
                <button v-for="(essFile, index) in item.holessenfiles" :key="index" class="btn-info"
                  @click="openLink(essFile.supplier)">
                  <i class="material-icons vtd-icon-2 vtd-mr-3"></i>
                  <span>
                    {{ capitalise(essFile.linklabel) }}
                  </span>
                </button>
              </div>

              <div v-if="item.operator === 'TRAILFINDERS JAPAN'">
                <video-stream :options="videoOptions" class="video-js" />
              </div>

              <button v-if="
                !isFriendFamily &&
                item.tourtype === 'CRUISE' &&
                showCruiseInfoBtn
              " class="voucher-btn mt-2" @click="openCruiseVoucher()">
                <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>Cruise Line Invoice</span>
              </button>

              <WidgetyItinerary v-if="item.tourtype === 'CRUISE'" :item="item" :cruiseData="cruiseData" />

              <button v-if="
                !isFriendFamily &&
                item.tourtype === 'CRUISE' &&
                cruiseInfoFound &&
                item.vehiclename !== ''
              " class="extra-info" @click="openCruiseInfoModal">
                <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>Ship Information</span>
              </button>
              <button v-if="item.holesswithdir" @click="openLink(item.holesswithdir)">
                <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>Click here for essential information on
                  {{ capitalise(item.operator) }}</span>
              </button>

              <button v-if="item.geocode && isWedding === 'false'" @click="
                () => {
                  $refs.MapRef.show(mapData);
                }
              ">
                <i class="material-icons vtd-icon-2 vtd-mr-3"></i><span>Map</span>
              </button>

              <!-- Secure docs modal btn -->
              <button v-if="checkSupplierDoc() === true && getFil === 'M'" class="secure-docs-btn"
                @click="openSecureDocsModal">
                <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i>
                <span>Documents we require for your booking</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="item.offers && item.offers[0]" class="extra-info-notes">
        Trailfinders Special Offers
        <ul>
          <li v-for="(offer, index) in item.offers" :key="index">
            {{ offer }}
          </li>
        </ul>
      </div>

      <div v-if="
        !returnAdditionalInformation('itinerary') &&
        !isFriendFamily &&
        item.tourtype !== 'CRUISE' &&
        item.p4text &&
        item.p4text[0] &&
        !item.showP4notes === false
      " class="extra-info-notes">
        <ul>
          <li v-for="(note, index) in item.p4text" :key="index" v-html="note" />
        </ul>
      </div>

      <div v-if="item.fnotes && item.fnotes[0]" class="extra-info-notes">
        Notes
        <ul>
          <li v-for="(note, index) in item.fnotes" :key="index">
            {{ note }}
          </li>
        </ul>
      </div>
      <div v-if="item.requests && item.requests[0]" class="extra-info-notes">
        <h4>Additional Information</h4>
        <ul>
          <li v-for="(request, index) in item.requests" :key="index">
            {{ request }}
          </li>
        </ul>
      </div>
    </div>
    <TourInfo v-if="
      item.operator.indexOf('G ADVENTURES') >= 0 ||
      item.operator.indexOf('TRUTRAVELS') >= 0
    " ref="TourInfoRef" :item="item" :tour_data="tour_data" />
    <IntrepidTripInfo v-if="
      item.operator.indexOf('INTREPID TRAVEL') >= 0 && item.advtourcode !== ''
    " ref="IntrepidTripInfoRef" :item="item" :trip_data="intrepid_holiday_data" />
    <ExodusHolidayInfo v-if="item.operator.indexOf('EXODUS') >= 0 && item.advtourcode !== ''" ref="ExodusHolidayInfoRef"
      :item="item" :holiday_data="exodus_holiday_data" />
    <ExploreTripInfo v-if="item.operator.indexOf('EXPLORE') >= 0 && item.advtourcode !== ''" ref="ExploreTripInfoRef"
      :item="item" :trip_data="explore_holiday_data" />
    <AATKingsTripInfo v-if="item.operator.indexOf('AAT KINGS') >= 0 && item.esctourcode !== ''"
      ref="AATKingsTripInfoRef" :item="item" />
    <CruiseInfo ref="CruiseInfoRef" :item="item" :cruiseData="cruiseData" />
    <Map v-if="isWedding === 'false'" ref="MapRef" />
    <SecureDocs v-if="checkSupplierDoc() && getFil === 'M'" ref="SecureDocsRef" :info="item" />
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Lightbox from "@/partials/light-box";
import ExtraInfoButtons from "@/partials/extra-info-buttons";
import TourHeader from "./header.vue";
import TourInfo from "@/partials/extra-info-buttons/tour-info";
import IntrepidTripInfo from "@/partials/extra-info-buttons/intrepid-trip-info";
import ExodusHolidayInfo from "@/partials/extra-info-buttons/exodus-holiday-info";
import ExploreTripInfo from "@/partials/extra-info-buttons/explore-trip-info";
import AATKingsTripInfo from "@/partials/extra-info-buttons/aatkings-trip-info";
import CruiseInfo from "@/partials/extra-info-buttons/cruise-info";
import SecureDocs from "@/partials/extra-info-buttons/secure-docs";
import WidgetyItinerary from "@/partials/extra-info-buttons/widgety-itinerary";
import MobileHeader from "./mobileheader.vue";
import videoImg from "@/partials/light-box/images/video-play.png";
import VideoStream from "@/modules/video-modal/video.vue";
import Map from "@/partials/map";
import dayjs from 'dayjs'
import { getSite, addCdnImageWidth } from "@/lib/utilities";
import { checkForCruiseLineInvoice } from "../../../services";
import { fetchWidgetyItinInfo } from "./services";
import {
  fetchExodusData,
  fetchExploreData,
  fetchIntrepidData,
  fetchGAdvData,
  postTouringPDF
} from "../../../tours/services";

export default {
  components: {
    Lightbox,
    TourHeader,
    MobileHeader,
    Map,
    TourInfo,
    ExodusHolidayInfo,
    IntrepidTripInfo,
    ExploreTripInfo,
    CruiseInfo,
    SecureDocs,
    ExtraInfoButtons,
    WidgetyItinerary,
    VideoStream,
    AATKingsTripInfo,
  },
  props: {
    item: {
      type: Object,
      default: null,
      showP4notes: true,
    },
  },
  data() {
    return {
      tour_data: {},
      dropdown: true,
      p4text: false,
      images: null,
      videoImg: videoImg,
      cruiseData: "",
      showCruiseInfoBtn: false,
      exodus_holiday_data: {},
      explore_holiday_data: {},
      intrepid_holiday_data: {},
      videoOptions: {
        autoplay: false,
        controls: true,
        poster: "https://cdn.trailfinders.com/anovygi7tc_jp_selfguide.jpg",
        sources: [
          {
            src: "https://vz-0c5f29ad-8d4.b-cdn.net/a238898a-7dfa-49bc-a8bd-f8339b505be3/playlist.m3u8",
            type: "application/x-mpegURL",
          },
        ],
      },
    };
  },
  async created() {
    this.setImages();
    if (this.item.tourtype === "CRUISE" && this.item.vehiclename !== "Not Supplied") {

      this.cruiseData = await fetchWidgetyItinInfo(
        this.item.vehiclename,
        dayjs(this.item.groupdate).format('YYYY-MM-DD'),
        dayjs(this.item.enddate).format('YYYY-MM-DD')
      );
    }
  },
  async mounted() {
    if (this.item.tourtype === "CRUISE") {
      // Create data object for cruise invoice check
      const cruiseData = {
        bookingNo: this.getBookingNumber,
        domain: this.userData.system,
      };
      const res = await checkForCruiseLineInvoice(cruiseData);
      if (res && res.data && res.data.success) {
        this.showCruiseInfoBtn = true;
      }
    }

    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
    if (this.item.advtourcode) {
      this.fetchData("exodus");
      this.fetchData("intrepid");
      this.tour_data = await fetchGAdvData(this.item.advtourcode);
    }
    if (this.item.advtourcode && this.item.tourdate) {
      this.fetchData("explore");
    }
  },
  computed: {
    ...mapState("auth", ["userData", "token"]),
    ...mapGetters({
      isFriendFamily: "friendFamily/isFriendFamily",
      getFil: "booking/getFil",
      getItineraryRaw: "booking/getItineraryRaw",
      getBookingNumber: "booking/getBookingNumber",
      isWedding: "booking/getWeddingAbroad",
      booking: "booking/getBooking",
    }),
    hasEssenFile() {
      if (
        this.item.holessenfiles &&
        Array.isArray(this.item.holessenfiles) &&
        this.item.holessenfiles.length > 0 &&
        this.item.holessenfiles[0] !== ""
      ) {
        return true;
      }
      return false;
    },
    mapData() {
      if (this.tourtype === "wedding" && this.item && this.item.geocode) {
        const coords = this.item.geocode.split(", ");
        return {
          lat: parseFloat(coords[0]),
          lng: parseFloat(coords[1]),
          zoom: 16,
        };
      }
      return null;
    },
    cruiseInfoFound() {
      if (
        this.item.vehiclename === "Not Supplied" ||
        this.item.vehiclename === "Not Found" ||
        this.cruiseData === null || undefined
      ) {
        return false;
      }
      return this.item.vehiclename;
    },
  },
  methods: {
    videoImage() {
      return typeof this.videoImg === "string"
        ? this.videoImg
        : this.videoImg["750x750"];
    },
    checkSupplierDoc() {
      return this.item && this.item.supplierDoc === "true";
    },
    openTourPDF(fileName) {
      let filePath = '';
      if (fileName.includes("/")) {
        filePath = fileName.split("/")[0];
        fileName = fileName.substring(fileName.lastIndexOf("/") + 1);
      }
      switch (filePath.toLowerCase()) {
        case "tsddoc":
          filePath = "tsd";
          break;
        case "tourdoc":
          filePath = this.item.tourtype === 'WEDDING PACKAGE' ? 'tourproduct/weddings' : 'tourproduct';
          break;
        default:
          filePath = "";
      }
      postTouringPDF(fileName, this.booking.user_information.token, this.getBookingNumber, filePath).then((res) => {
        if (res) {
          const file = new Blob([res], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          const a = document.createElement("a");
          a.href = fileURL;
          a.setAttribute("download", fileName);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(fileURL);
        } else {
          this.$bvToast.toast("The PDF could not be downloaded. Please contact us via eTrail.", {
            title: `Error Getting PDF`,
            variant: 'danger',
            solid: true
          })
        }
      }).catch((err) => {
        this.$bvToast.toast("The PDF could not be downloaded. Please contact us via eTrail.", {
          title: `Error Getting PDF`,
          variant: 'danger',
          solid: true
        })
      });
    },
    openTourInfoModal() {
      this.$refs.TourInfoRef.show();
    },
    openIntrepidTripInfoModal() {
      this.$refs.IntrepidTripInfoRef.show();
    },
    openExodusHolidayInfoModal() {
      this.$refs.ExodusHolidayInfoRef.show();
    },
    openExploreTripInfoModal() {
      this.$refs.ExploreTripInfoRef.show();
    },
    openTrafalgarTripInfoModal() {
      this.$refs.TrafalgarTripInfoRef.show();
    },
    openAATKingsTripInfoModal() {
      this.$refs.AATKingsTripInfoRef.show();
    },
    openCruiseInfoModal() {
      this.$refs.CruiseInfoRef.show();
    },
    openSecureDocsModal() {
      this.$refs.SecureDocsRef.show();
    },
    setImages() {
      if (this.item && this.item.imageurl) {
        if (Array.isArray(this.item.imageurl)) {
          this.images = [];
          this.item.imageurl.forEach((element) => {
            if (element.indexOf("http") >= 0) {
              this.images.push({
                src: element,
                thumbnailWidth: "293px",
              });
            }
          });
        } else {
          if (this.item.tourtype) {
            this.images = new Array({
              src:
                this.item.tourtype.toUpperCase() === "CRUISE" &&
                  this.item.imageurl["750x750"]
                  ? this.item.imageurl["750x750"]
                  : this.item.imageurl,
              thumbnailWidth: "293px",
            });
          } else if (this.item.imageurl) {
            this.images = new Array({
              src: this.item.imageurl,
              thumbnailWidth: "293px",
            });
          }
        }
      }
      if (!this.images) {
        return;
      }

      if (
        this.images[0].src.indexOf(".m3u8") !== -1 &&
        this.item.videoThumbnail
      ) {
        this.videoImg = `${this.item.videoThumbnail}?width=300`;
      } else if (this.images[0].src.indexOf(".m3u8") !== -1) {
        this.videoImg = `${this.images[0].src.replace(
          "playlist.m3u8",
          "thumbnail.jpg"
        )}?width=300`;
      } else {
        this.videoImg = addCdnImageWidth(this.images[0].src);
      }

      if (this.images[0].src.indexOf(".mp4") !== -1) {
        let _tmp = this.images[0].src.split("/");
        _tmp = _tmp[_tmp.length - 1];
        let _jpeg = `${_tmp.split(".")[0]}.jpeg`;
        this.videoImg = `https://webimages.trailfinders.com/video/upload/c_fill,g_south,so_1/l_play-icon/w_auto/video/${_jpeg}`;
      } else if (this.images[0].src.includes("youtu")) {
        this.videoImg = this.item.videoCover;
      } else {
        this.videoImg = addCdnImageWidth(this.images[0].src);
      }
      if (this.item.videoThumbnail) {
        this.videoImg = addCdnImageWidth(this.item.videoThumbnail);
      }
    },
    toggleExpand(value) {
      this.dropdown = value;
    },
    expandAll() {
      this.dropdown = true;
    },
    collapseAll() {
      this.dropdown = false;
    },
    returnAdditionalInformation(key) {
      // Specifically for the additional rows after expanderItems
      // Check to see if p4text is empty
      this.item.showP4notes = true;
      if (
        !this.item.p4text ||
        (Array.isArray(this.item.p4text) && this.item.p4text[0] === "")
      ) {
        if (
          this.item.tour_details &&
          this.item.tour_details[key] &&
          this.item.tour_details[key] !== ""
        ) {
          return this.item.tour_details[key];
        }
      } else if (
        this.item.p4text &&
        key === "itinerary" &&
        this.item.showP4notes === true
      ) {
        return this.item.p4text[0];
      }
    },
    openLink(_link) {
      window.open(`https://www.trailfinders.${getSite()}${_link}`, "_blank");
    },

    async openVoucher(vouchno) {
      setTimeout(() => {
        window.open(
          `https://www.trailfinders.${getSite()}/travel-vouchers/${this.getBookingNumber
          }_${vouchno}.pdf`,
          "_blank"
        );
      }, 1000);
    },

    async openCruiseVoucher() {
      window.open(
        `https://www.trailfinders.${getSite()}/tourdoc/cruise/${this.getBookingNumber
        }.pdf`,
        "_blank"
      );
    },
    capitalise(text) {
      text = text.toLowerCase();
      let re = /(\b[a-z](?!\s))/g;
      let regexText = text.replace(re, (x) => x.toUpperCase());

      return regexText;
    },
    async fetchData(supplier) {
      if (supplier === "exodus") {
        let res = await fetchExodusData(this.item.advtourcode);
        if (res && res.data) {
          return (this.exodus_holiday_data = res.data);
        }
      }
      if (supplier === "explore") {
        let tourcode = this.item.advtourcode
        if (tourcode.includes('/')) {
          const tourcodeArr = tourcode.split('/')
          tourcode = tourcodeArr.join('-')
        }
        const res = await fetchExploreData(
          tourcode,
          this.item.tourdate
        );
        if (res) {
          return (this.explore_holiday_data = res);
        }
      }
      if (supplier === "intrepid") {
        // Intrepid Tour Season 2024, 2025, 2026 (options are current year, next year or the year after)
        let season = this.item.groupdate;
        const res = await fetchIntrepidData(this.item.advtourcode, season);
        if (res) {
          return (this.intrepid_holiday_data = res);
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "../styles.scss";

.custom-video-player .playArrow {
  top: 47% !important;
}
</style>
